import { memo, ReactElement } from 'react';
import { Button } from '@/common/ui';
import * as S from './VStickyFooter.styles';
import { ReviewsBlock } from '@/entities/Reviews/ui/ReviewBlock';
import { convertRatingToStars } from '../../app/utils/mapVProductToTabs';
import { getNormalisedPrice } from '@/common/app/utils/getNormalisedPrice';
import {
    NewPrice,
    PriceMobile,
    PriceSection,
} from '@/screens/ActivityPage/ui/StickyFooter/StickyFooter.styles';

type VStickyFooterProps = {
    totalReviews: number;
    rating: number;
    price: number;
    currency: string;
    onBookNow: () => void;
};

const VStickyFooterContainer = ({
    totalReviews,
    rating,
    price,
    currency,
    onBookNow,
}: VStickyFooterProps): ReactElement => {
    const ratingStars = convertRatingToStars(rating);
    const ratingStr = rating.toFixed(1);
    const priceWithComma = getNormalisedPrice(price, currency);

    return (
        <S.VStickyFooterContainer data-test-id="VSticky_footer">
            <S.VFooterContent>
                <S.VRatingSection>
                    {!!priceWithComma && (
                        <PriceMobile>
                            From&nbsp; &nbsp;
                            <NewPrice>{priceWithComma}</NewPrice>
                        </PriceMobile>
                    )}
                    <ReviewsBlock
                        ratingStars={ratingStars}
                        rating={ratingStr}
                        rateCount={totalReviews}
                        onClick={onBookNow}
                        size="medium"
                        emptyReviewsMsg=""
                        tooltip="Click to see reviews on external site"
                    />
                </S.VRatingSection>
                {!!priceWithComma && (
                    <PriceSection>
                        From&nbsp; &nbsp;
                        <NewPrice>{priceWithComma}</NewPrice>
                    </PriceSection>
                )}
                <S.VButtonSection>
                    <Button onClick={onBookNow} variant="primary">
                        Check Rates & Availability
                    </Button>
                </S.VButtonSection>
            </S.VFooterContent>
        </S.VStickyFooterContainer>
    );
};

export const VStickyFooter = memo(VStickyFooterContainer);
